import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { CountryActions } from './country.actions';
import { ICountryState } from './country.state';

export const initialCountryState: ICountryState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const countryReducerFn = createReducer(
  initialCountryState,
  on(CountryActions.reset, (state: ICountryState, action) => {
    return new StateBuilder<ICountryState>(initialCountryState).build();
  }),
  on(CountryActions.load, (state: ICountryState, action) => {
    return new StateBuilder<ICountryState>(state).toLoading().build();
  }),
  on(CountryActions.loadSuccess, (state: ICountryState, action) => {
    return new StateBuilder<ICountryState>(state, action).toLoaded().build();
  }),
  on(CountryActions.submit, (state: ICountryState, action) => {
    return new StateBuilder<ICountryState>(state, action).toLoading().build();
  }),
  on(CountryActions.submitSuccess, (state: ICountryState, action) => {
    return new StateBuilder<ICountryState>(state, action).toLoaded().build();
  })
);

export function countryReducer(state: ICountryState | undefined, action: Action) {
  return countryReducerFn(state, action);
}
